module.exports = __webpack_public_path__ + "static/media/quote-right-solid.dacf1007.svg";